import { render, staticRenderFns } from "./distributionVoucher.vue?vue&type=template&id=1bdc278f&scoped=true"
import script from "./distributionVoucher.vue?vue&type=script&lang=js"
export * from "./distributionVoucher.vue?vue&type=script&lang=js"
import style0 from "./distributionVoucher.vue?vue&type=style&index=0&id=1bdc278f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc278f",
  null
  
)

export default component.exports